import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import styles from './VipRenewal.module.css';

const LIFETIME_PLAN_IDS = ['lifetime', 'liefetime'];

const VipLifetime = () => {
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/plans');
        if (!cancelled && Array.isArray(data)) {
          const lifetime = data.find((p) =>
            LIFETIME_PLAN_IDS.includes(String(p.id || '').toLowerCase())
          );
          setPlan(lifetime || null);
        } else if (!cancelled) {
          setPlan(null);
        }
      } catch {
        if (!cancelled) setPlan(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handlePayment = async () => {
    if (!plan) return;
    try {
      const { data } = await api.post('/payment/create-checkout-session', {
        plan_id: plan.id,
      });
      if (data?.checkout_url) {
        window.location.href = data.checkout_url;
      }
    } catch (err) {
      const detail =
        err?.response?.data?.detail || err?.message || '创建支付会话失败';
      alert(detail);
    }
  };

  const currencySymbol = (currency) => {
    const map = { CNY: '¥', USD: '$', EUR: '€', GBP: '£' };
    return map[currency] || currency;
  };

  const comparisons = [
    { label: '每日阅读章节', free: '2 章 / 天', vip: '无限制', icon: 'menu_book' },
    { label: '每日收藏单词', free: '10 个 / 天', vip: '无限制', icon: 'translate' },
    { label: '每日收藏句子', free: '5 条 / 天', vip: '无限制', icon: 'format_quote' },
    { label: '每日添加笔记', free: '3 条 / 天', vip: '无限制', icon: 'edit_note' },
    { label: '章节 PDF 下载', free: '10次', vip: '无限次', icon: 'download' },
  ];

  return (
    <div className={styles.vipRenewal}>
      <div className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <h1 className={styles.title}>终身 VIP</h1>
      </div>

      <div className={styles.content}>
        <div className={styles.hero}>
          <div className={styles.heroIcon}>
            <span className="material-symbols-outlined">workspace_premium</span>
          </div>
          <h2 className={styles.heroTitle}>终身 VIP 会员</h2>
          <p className={styles.heroDesc}>一次付费，终身享受全部功能，无限学习体验</p>
        </div>

        <div className={styles.plans}>
          {loading ? (
            <p style={{ textAlign: 'center', color: '#999', padding: '2rem 0' }}>
              加载套餐中…
            </p>
          ) : !plan ? (
            <p style={{ textAlign: 'center', color: '#999', padding: '2rem 0' }}>
              暂无终身套餐，请稍后重试
            </p>
          ) : (
            <div
              className={`${styles.planCard} ${styles.planCardSelected}`}
              onClick={() => {}}
            >
              {plan.badge && (
                <div className={styles.planBadge}>{plan.badge}</div>
              )}
              <div className={styles.planHeader}>
                <h3 className={styles.planName}>{plan.name}</h3>
                <div className={styles.planPrice}>
                  <span className={styles.planPriceSymbol}>
                    {currencySymbol(plan.currency)}
                  </span>
                  <span className={styles.planPriceAmount}>{plan.price}</span>
                  <span className={styles.planPriceUnit}>/{plan.unit_label || '终身'}</span>
                </div>
                {plan.savings_text && (
                  <p className={styles.planSavings}>{plan.savings_text}</p>
                )}
                <p className={styles.planPeriod}>{plan.period_label || '一次付费，终身使用'}</p>
              </div>
              <div className={styles.planFeatures}>
                {(plan.features || []).map((feature, index) => (
                  <div key={index} className={styles.planFeature}>
                    <span className={`material-symbols-outlined ${styles.featureIcon}`}>
                      check_circle
                    </span>
                    <span className={styles.featureText}>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className={styles.comparisonSection}>
          <h3 className={styles.comparisonTitle}>
            <span className="material-symbols-outlined">compare</span>
            免费用户 vs 终身 VIP
          </h3>
          <div className={styles.comparisonTable}>
            <div className={styles.comparisonHeader}>
              <span className={styles.comparisonColLabel}>功能</span>
              <span className={styles.comparisonColFree}>免费</span>
              <span className={styles.comparisonColVip}>终身 VIP</span>
            </div>
            {comparisons.map((item, index) => (
              <div key={index} className={styles.comparisonRow}>
                <span className={styles.comparisonLabel}>
                  <span className={`material-symbols-outlined ${styles.comparisonIcon}`}>{item.icon}</span>
                  {item.label}
                </span>
                <span className={styles.comparisonFree}>{item.free}</span>
                <span className={styles.comparisonVip}>
                  <span className={`material-symbols-outlined ${styles.comparisonCheck}`}>check</span>
                  {item.vip}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.footer}>
          <button
            className={styles.payBtn}
            onClick={handlePayment}
            disabled={!plan}
          >
            立即开通终身 VIP
          </button>
          <p className={styles.footerNote}>
            开通会员即表示您同意我们的<a href="/terms#terms">服务条款</a>和<a href="/terms#privacy">隐私政策</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VipLifetime;
